import { render, staticRenderFns } from "./btramto.vue?vue&type=template&id=3b5734d6"
import script from "./btramto.vue?vue&type=script&lang=js"
export * from "./btramto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports